import app from '../app.first';
import $ from 'jquery';

app.JobListing = class extends app.Component {
	onReady() {
        let filterButton = $('.filter-menu-button');
        let shown = true;

        if ($('.filter-container').css('display') == 'none') {
            shown = false
        }

        filterButton.click(() => {
            if (shown) {
                $('.filter-container').fadeOut(200)

                $('.job-listing-overlay').fadeOut(200)
            } else {
                $('.filter-container').fadeIn(200)
                $('.job-listing-overlay').fadeIn(200)
            }

            shown = !shown
        })
	}
}